import lang from '@/lang'
import { subscriptionTypes, SubscriptionTypeTypes, SUBSCRIPTION_MODULES } from '@/modules/base/util/constants'
import { Type } from '@/redux/ducks/subscription/types/details'

import {
  WatchLaterRounded as ClockIcon,
  VisibilityRounded as EyeIcon,
  LoopRounded as LoopIcon,
  SettingsRounded as SettingsIcon,
  ReceiptLongRounded as ReceiptLongIcon,
  FormatListBulletedRounded as ListIcon,
  CalculateRounded as CalculateIcon,
  DescriptionRounded as FileIcon,
  TimerRounded as TimerIcon,
  FindInPageRounded as FindInPageIcon,
  SchemaRounded as SchemaIcon,
  SearchRounded as SearchIcon,
  WarningRounded as WarningIcon,
  AttachFileRounded as AttachFileIcon,
  WarehouseRounded as WarehouseIcon,
  NotificationsRounded as NotificationIcon,
  SentimentSatisfiedRounded as SentimentSatisfiedIcon,
  MonitorRounded as MonitorIcon,
  FileCopyRounded as FileCopyIcon,
  InsertDriveFileRounded as InsertDriveFileIcon,
  WindowRounded as WindowIcon,
  GroupRounded as GroupIcon,
  PersonAddAlt1Rounded as PersonAddAlt1Icon,
  SendRounded as SendIcon,
  InsertPageBreakRounded as FileScanIcon,
  AccountTreeRounded as RouteTreeIcon,
  CheckCircleRounded as CheckIcon,
  NoteAddRounded as FileNew,
  AccountTreeRounded as BranchIcon,
  EuroRounded as EuroIcon,
  ApiRounded as ApiIcon,
  VpnKeyRounded as VpnKeyIcon,
  ExtensionRounded as ExtensionIcon,
} from '@mui/icons-material'
import TodosBannerImage from '@assets/images/feature-modals/todos.png'
import OrdersBannerImage from '@assets/images/feature-modals/orders.png'
import RecurringInvoiceBannerImage from '@assets/images/feature-modals/recurring-invoice.png'
import DepositInvoiceBannerImage from '@assets/images/feature-modals/deposit-invoice.png'
import ProjectsBannerImage from '@assets/images/feature-modals/projects.png'
import BankingBannerImage from '@assets/images/feature-modals/banking.png'
import ExpensesBannerImage from '@assets/images/feature-modals/expenses.png'
import DunningBannerImage from '@assets/images/feature-modals/dunning.png'
import EmailBannerImage from '@assets/images/feature-modals/email.png'
import InventoryBannerImage from '@assets/images/feature-modals/inventory.png'
import AutoDunningBannerImage from '@assets/images/feature-modals/auto-dunning.png'
import EsigningBannerImage from '@assets/images/feature-modals/esigning.png'
import EInvoicesBannerImage from '@assets/images/feature-modals/einvoices.png'
import OptionalPositionsBannerImage from '@assets/images/feature-modals/optional-positions.png'
import AlternativePositionsBannerImage from '@assets/images/feature-modals/alternative-positions.png'
import LetterPapersBannerImage from '@assets/images/feature-modals/briefpapier.png'
import CollectiveInvoiceBannerImage from '@assets/images/feature-modals/collective-invoice.png'
import GraduatedPriceBannerImage from '@assets/images/feature-modals/graduated-price.png'
import InviteUserBannerImage from '@assets/images/feature-modals/invite-user.png'
import RevenueBannerImage from '@assets/images/feature-modals/revenue.png'
import TaxReportBannerImage from '@assets/images/feature-modals/tax-report.png'
import EconomicAssetBannerImage from '@assets/images/feature-modals/economic-asset.png'
import PurchasesBanner from '@assets/images/feature-modals/purchases.png'
import PartialAndCollectiveDeliveryNotesBanner from '@assets/images/feature-modals/partial-and-collective-delivery-notes.png'
import PartialInvoiceBannerImage from '@assets/images/feature-modals/partial-invoice.png'

import CopyLinkIcon from '@assets/images/icons/copy_link.svg'
import ListCheckIcon from '@assets/images/icons/list_check.svg'
import CalendarClockIcon from '@assets/images/icons/calendar_clock.svg'
import BusinessIcon from '@assets/images/icons/business.svg'
import KeyboardOnscreenIcon from '@assets/images/icons/keyboard_onscreen.svg'
import FileCheckIcon from '@assets/images/icons/file_check.svg'
import MailIcon from '@assets/images/email-provider-logos/mail.svg'
import DataBaseUploadCheckIcon from '@assets/images/icons/database_upload_check.svg'
import ListAltIcon from '@assets/images/icons/list_alt.svg'
import PaymentsIcon from '@assets/images/icons/payments.svg'
import BookIcon from '@assets/images/icons/book.svg'
import FileRenewIcon from '@assets/images/icons/file_renew.svg'
import NoteStackIcon from '@assets/images/icons/note_stack.svg'
import ShieldLockedIcon from '@assets/images/icons/shield_locked.svg'
import ShelvesIcon from '@assets/images/icons/shelves.svg'
import DeliveryIcon from '@assets/images/icons/delivery2.svg'
import SignatureIcon from '@assets/images/icons/signature2.svg'
import PathIcon from '@assets/images/icons/path.svg'
import SignaturePenIcon from '@assets/images/icons/signature_pen.svg'
import ListChecklistIcon from '@assets/images/icons/list_checklist.svg'
import FileEuroIcon from '@assets/images/icons/file_euro.svg'
import MoneyBagIcon from '@assets/images/icons/money_bag.svg'
import StorefrontIcon from '@assets/images/icons/storefront.svg'
import PersonCheckIcon from '@assets/images/icons/person_check.svg'
import ArrowSelectorToolIcon from '@assets/images/icons/arrow_selector_tool.svg'
import CheckbookIcon from '@assets/images/icons/checkbook.svg'
import AwaitedDeliveryIcon from '@assets/images/icons/awaitedDelivery.svg'

export const FeatureTypes = {
  TODO: 'todo',
  LETTERS: 'letters',
  ORDERS_AND_DELIVERY_NOTES: 'orders-and-delivery-note',
  RECURRING_INVOICE: 'recurring-invoice',
  PROJECTS: 'projects',
  BANKING: 'banking',
  TIMETRACKING: 'timetracking',
  EXPENSES: 'expenses',
  DUNNING: 'dunning',
  INVENTORY: 'inventory',
  AUTO_DUNNING: 'auto-dunning',
  E_SIGNING: 'e-signing',
  E_INVOICES: 'e-invoices',
  OPTIONAL_POSITIONS: 'optional-positions',
  ALTERNATIVE_POSITIONS: 'alternative-positions',
  LETTER_PAPERS: 'letter-papers',
  COLLECTIVE_INVOICE: 'collective-invoice',
  GRADUATED_PRICE: 'graduated-price',
  INVITE_USER: 'invite-user',
  REVENUE: 'revenue',
  TAX_REPORT: 'tax-report',
  ECONOMIC_ASSET: 'economic-asset',
  MAILBOX: 'mailbox',
  PURCHASES: 'purchases',
  COLLECTIVE_DELIVERY_NOTES: 'collectiveDeliveryNotes',
  PARTIAL_INVOICE: 'partialInvoice',
  PUBLIC_API: 'public-api',
}

export type FeatureType = typeof FeatureTypes[keyof typeof FeatureTypes]

export type FeatureConfig = {
  title: string
  description: string
  subscriptionType: Type
  type?: string
  moduleToAdd?: string
  subscriptionTypeLabel?: string
  featureMedia?: string
  mediaType?: 'video' | 'image'
  features: {
    title: string
    description: string
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>
  }[]
}

const featureLang = lang.featureLockedModal.features

const featureConfig = {
  [FeatureTypes.TODO]: {
    title: featureLang[FeatureTypes.TODO].title,
    description: featureLang[FeatureTypes.TODO].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.TODO].subscriptionTypeLabel,
    featureMedia: TodosBannerImage,
    features: [
      { title: featureLang[FeatureTypes.TODO].feature1.title, description: featureLang[FeatureTypes.TODO].feature1.description, icon: ListCheckIcon },
      { title: featureLang[FeatureTypes.TODO].feature2.title, description: featureLang[FeatureTypes.TODO].feature2.description, icon: CopyLinkIcon },
      { title: featureLang[FeatureTypes.TODO].feature3.title, description: featureLang[FeatureTypes.TODO].feature3.description, icon: NotificationIcon },
      { title: featureLang[FeatureTypes.TODO].feature4.title, description: featureLang[FeatureTypes.TODO].feature4.description, icon: CalendarClockIcon },
    ],
  },
  [FeatureTypes.LETTERS]: {
    title: featureLang[FeatureTypes.LETTERS].title,
    description: featureLang[FeatureTypes.LETTERS].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.LETTERS].subscriptionTypeLabel,
    featureMedia: 'https://www.youtube.com/embed/gU09SN6VV0I?si=o1uiRmmODKZligjh',
    mediaType: 'video',
    features: [
      { title: featureLang[FeatureTypes.LETTERS].feature1.title, description: featureLang[FeatureTypes.LETTERS].feature1.description, icon: BusinessIcon },
      { title: featureLang[FeatureTypes.LETTERS].feature2.title, description: featureLang[FeatureTypes.LETTERS].feature2.description, icon: KeyboardOnscreenIcon },
      { title: featureLang[FeatureTypes.LETTERS].feature3.title, description: featureLang[FeatureTypes.LETTERS].feature3.description, icon: FileCheckIcon },
      { title: featureLang[FeatureTypes.LETTERS].feature4.title, description: featureLang[FeatureTypes.LETTERS].feature4.description, icon: SearchIcon },
      { title: featureLang[FeatureTypes.LETTERS].feature5.title, description: featureLang[FeatureTypes.LETTERS].feature5.description, icon: MailIcon },
    ],
  },
  [FeatureTypes.ORDERS_AND_DELIVERY_NOTES]: {
    title: featureLang[FeatureTypes.ORDERS_AND_DELIVERY_NOTES].title,
    description: featureLang[FeatureTypes.ORDERS_AND_DELIVERY_NOTES].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.ORDERS_AND_DELIVERY_NOTES].subscriptionTypeLabel,
    featureMedia: OrdersBannerImage,
    features: [
      {
        title: featureLang[FeatureTypes.ORDERS_AND_DELIVERY_NOTES].feature1.title,
        description: featureLang[FeatureTypes.ORDERS_AND_DELIVERY_NOTES].feature1.description,
        icon: SettingsIcon,
      },
      {
        title: featureLang[FeatureTypes.ORDERS_AND_DELIVERY_NOTES].feature2.title,
        description: featureLang[FeatureTypes.ORDERS_AND_DELIVERY_NOTES].feature2.description,
        icon: DataBaseUploadCheckIcon,
      },
      {
        title: featureLang[FeatureTypes.ORDERS_AND_DELIVERY_NOTES].feature3.title,
        description: featureLang[FeatureTypes.ORDERS_AND_DELIVERY_NOTES].feature3.description,
        icon: ListAltIcon,
      },
      {
        title: featureLang[FeatureTypes.ORDERS_AND_DELIVERY_NOTES].feature4.title,
        description: featureLang[FeatureTypes.ORDERS_AND_DELIVERY_NOTES].feature4.description,
        icon: SettingsIcon,
      },
      {
        title: featureLang[FeatureTypes.ORDERS_AND_DELIVERY_NOTES].feature5.title,
        description: featureLang[FeatureTypes.ORDERS_AND_DELIVERY_NOTES].feature5.description,
        icon: MailIcon,
      },
    ],
  },
  [FeatureTypes.RECURRING_INVOICE]: {
    title: featureLang[FeatureTypes.RECURRING_INVOICE].title,
    description: featureLang[FeatureTypes.RECURRING_INVOICE].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.RECURRING_INVOICE].subscriptionTypeLabel,
    featureMedia: RecurringInvoiceBannerImage,
    features: [
      { title: featureLang[FeatureTypes.RECURRING_INVOICE].feature1.title, description: featureLang[FeatureTypes.RECURRING_INVOICE].feature1.description, icon: SettingsIcon },
      { title: featureLang[FeatureTypes.RECURRING_INVOICE].feature2.title, description: featureLang[FeatureTypes.RECURRING_INVOICE].feature2.description, icon: LoopIcon },
      { title: featureLang[FeatureTypes.RECURRING_INVOICE].feature3.title, description: featureLang[FeatureTypes.RECURRING_INVOICE].feature3.description, icon: ClockIcon },
      { title: featureLang[FeatureTypes.RECURRING_INVOICE].feature4.title, description: featureLang[FeatureTypes.RECURRING_INVOICE].feature4.description, icon: EyeIcon },
    ],
  },
  [FeatureTypes.PROJECTS]: {
    title: featureLang[FeatureTypes.PROJECTS].title,
    description: featureLang[FeatureTypes.PROJECTS].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.PROJECTS].subscriptionTypeLabel,
    featureMedia: DepositInvoiceBannerImage,
    features: [
      { title: featureLang[FeatureTypes.PROJECTS].feature1.title, description: featureLang[FeatureTypes.PROJECTS].feature1.description, icon: CalculateIcon },
      { title: featureLang[FeatureTypes.PROJECTS].feature2.title, description: featureLang[FeatureTypes.PROJECTS].feature2.description, icon: ListIcon },
      { title: featureLang[FeatureTypes.PROJECTS].feature3.title, description: featureLang[FeatureTypes.PROJECTS].feature3.description, icon: ReceiptLongIcon },
      { title: featureLang[FeatureTypes.PROJECTS].feature4.title, description: featureLang[FeatureTypes.PROJECTS].feature4.description, icon: PaymentsIcon },
    ],
  },
  [FeatureTypes.TIMETRACKING]: {
    title: featureLang[FeatureTypes.TIMETRACKING].title,
    description: featureLang[FeatureTypes.TIMETRACKING].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.TIMETRACKING].subscriptionTypeLabel,
    featureMedia: ProjectsBannerImage,
    features: [
      { title: featureLang[FeatureTypes.TIMETRACKING].feature1.title, description: featureLang[FeatureTypes.TIMETRACKING].feature1.description, icon: EyeIcon },
      { title: featureLang[FeatureTypes.TIMETRACKING].feature2.title, description: featureLang[FeatureTypes.TIMETRACKING].feature2.description, icon: ClockIcon },
      { title: featureLang[FeatureTypes.TIMETRACKING].feature3.title, description: featureLang[FeatureTypes.TIMETRACKING].feature3.description, icon: FileIcon },
      { title: featureLang[FeatureTypes.TIMETRACKING].feature4.title, description: featureLang[FeatureTypes.TIMETRACKING].feature4.description, icon: TimerIcon },
    ],
  },
  [FeatureTypes.BANKING]: {
    title: featureLang[FeatureTypes.BANKING].title,
    description: featureLang[FeatureTypes.BANKING].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.BANKING].subscriptionTypeLabel,
    featureMedia: BankingBannerImage,
    features: [
      { title: featureLang[FeatureTypes.BANKING].feature1.title, description: featureLang[FeatureTypes.BANKING].feature1.description, icon: ReceiptLongIcon },
      { title: featureLang[FeatureTypes.BANKING].feature2.title, description: featureLang[FeatureTypes.BANKING].feature2.description, icon: FindInPageIcon },
      { title: featureLang[FeatureTypes.BANKING].feature3.title, description: featureLang[FeatureTypes.BANKING].feature3.description, icon: BookIcon },
      { title: featureLang[FeatureTypes.BANKING].feature4.title, description: featureLang[FeatureTypes.BANKING].feature4.description, icon: SchemaIcon },
    ],
  },
  [FeatureTypes.EXPENSES]: {
    title: featureLang[FeatureTypes.EXPENSES].title,
    description: featureLang[FeatureTypes.EXPENSES].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.EXPENSES].subscriptionTypeLabel,
    featureMedia: ExpensesBannerImage,
    features: [
      { title: featureLang[FeatureTypes.EXPENSES].feature1.title, description: featureLang[FeatureTypes.EXPENSES].feature1.description, icon: NoteStackIcon },
      { title: featureLang[FeatureTypes.EXPENSES].feature2.title, description: featureLang[FeatureTypes.EXPENSES].feature2.description, icon: SearchIcon },
      { title: featureLang[FeatureTypes.EXPENSES].feature3.title, description: featureLang[FeatureTypes.EXPENSES].feature3.description, icon: FileRenewIcon },
      { title: featureLang[FeatureTypes.EXPENSES].feature4.title, description: featureLang[FeatureTypes.EXPENSES].feature4.description, icon: SchemaIcon },
    ],
  },
  [FeatureTypes.DUNNING]: {
    title: featureLang[FeatureTypes.DUNNING].title,
    description: featureLang[FeatureTypes.DUNNING].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.DUNNING].subscriptionTypeLabel,
    featureMedia: DunningBannerImage,
    features: [
      { title: featureLang[FeatureTypes.DUNNING].feature1.title, description: featureLang[FeatureTypes.DUNNING].feature1.description, icon: WarningIcon },
      { title: featureLang[FeatureTypes.DUNNING].feature2.title, description: featureLang[FeatureTypes.DUNNING].feature2.description, icon: SchemaIcon },
      { title: featureLang[FeatureTypes.DUNNING].feature3.title, description: featureLang[FeatureTypes.DUNNING].feature3.description, icon: ListAltIcon },
      { title: featureLang[FeatureTypes.DUNNING].feature4.title, description: featureLang[FeatureTypes.DUNNING].feature4.description, icon: ClockIcon },
    ],
  },
  [FeatureTypes.MAILBOX]: {
    title: featureLang[FeatureTypes.MAILBOX].title,
    description: featureLang[FeatureTypes.MAILBOX].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.MAILBOX].subscriptionTypeLabel,
    featureMedia: EmailBannerImage,
    features: [
      { title: featureLang[FeatureTypes.MAILBOX].feature1.title, description: featureLang[FeatureTypes.MAILBOX].feature1.description, icon: MailIcon },
      { title: featureLang[FeatureTypes.MAILBOX].feature2.title, description: featureLang[FeatureTypes.MAILBOX].feature2.description, icon: AttachFileIcon },
      { title: featureLang[FeatureTypes.MAILBOX].feature3.title, description: featureLang[FeatureTypes.MAILBOX].feature3.description, icon: ReceiptLongIcon },
      { title: featureLang[FeatureTypes.MAILBOX].feature4.title, description: featureLang[FeatureTypes.MAILBOX].feature4.description, icon: ShieldLockedIcon },
    ],
  },
  [FeatureTypes.INVENTORY]: {
    title: featureLang[FeatureTypes.INVENTORY].title,
    description: featureLang[FeatureTypes.INVENTORY].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    type: subscriptionTypes.WARENWIRTSCHAFT_2026,
    subscriptionTypeLabel: featureLang[FeatureTypes.INVENTORY].subscriptionTypeLabel,
    featureMedia: InventoryBannerImage,
    features: [
      { title: featureLang[FeatureTypes.INVENTORY].feature1.title, description: featureLang[FeatureTypes.INVENTORY].feature1.description, icon: ShelvesIcon },
      { title: featureLang[FeatureTypes.INVENTORY].feature2.title, description: featureLang[FeatureTypes.INVENTORY].feature2.description, icon: ReceiptLongIcon },
      { title: featureLang[FeatureTypes.INVENTORY].feature3.title, description: featureLang[FeatureTypes.INVENTORY].feature3.description, icon: DeliveryIcon },
      { title: featureLang[FeatureTypes.INVENTORY].feature4.title, description: featureLang[FeatureTypes.INVENTORY].feature4.description, icon: WarehouseIcon },
    ],
  },
  [FeatureTypes.AUTO_DUNNING]: {
    title: featureLang[FeatureTypes.AUTO_DUNNING].title,
    description: featureLang[FeatureTypes.AUTO_DUNNING].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.AUTO_DUNNING].subscriptionTypeLabel,
    featureMedia: AutoDunningBannerImage,
    features: [
      { title: featureLang[FeatureTypes.AUTO_DUNNING].feature1.title, description: featureLang[FeatureTypes.AUTO_DUNNING].feature1.description, icon: NotificationIcon },
      { title: featureLang[FeatureTypes.AUTO_DUNNING].feature2.title, description: featureLang[FeatureTypes.AUTO_DUNNING].feature2.description, icon: PaymentsIcon },
      { title: featureLang[FeatureTypes.AUTO_DUNNING].feature3.title, description: featureLang[FeatureTypes.AUTO_DUNNING].feature3.description, icon: SentimentSatisfiedIcon },
      { title: featureLang[FeatureTypes.AUTO_DUNNING].feature4.title, description: featureLang[FeatureTypes.AUTO_DUNNING].feature4.description, icon: SchemaIcon },
      { title: featureLang[FeatureTypes.AUTO_DUNNING].feature5.title, description: featureLang[FeatureTypes.AUTO_DUNNING].feature5.description, icon: ClockIcon },
    ],
  },
  [FeatureTypes.E_SIGNING]: {
    title: featureLang[FeatureTypes.E_SIGNING].title,
    description: featureLang[FeatureTypes.E_SIGNING].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.E_SIGNING].subscriptionTypeLabel,
    featureMedia: EsigningBannerImage,
    features: [
      { title: featureLang[FeatureTypes.E_SIGNING].feature1.title, description: featureLang[FeatureTypes.E_SIGNING].feature1.description, icon: SignatureIcon },
      { title: featureLang[FeatureTypes.E_SIGNING].feature2.title, description: featureLang[FeatureTypes.E_SIGNING].feature2.description, icon: MonitorIcon },
      { title: featureLang[FeatureTypes.E_SIGNING].feature3.title, description: featureLang[FeatureTypes.E_SIGNING].feature3.description, icon: ShieldLockedIcon },
      { title: featureLang[FeatureTypes.E_SIGNING].feature4.title, description: featureLang[FeatureTypes.E_SIGNING].feature4.description, icon: SearchIcon },
    ],
  },
  [FeatureTypes.E_INVOICES]: {
    title: featureLang[FeatureTypes.E_INVOICES].title,
    description: featureLang[FeatureTypes.E_INVOICES].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.E_INVOICES].subscriptionTypeLabel,
    featureMedia: EInvoicesBannerImage,
    features: [
      { title: featureLang[FeatureTypes.E_INVOICES].feature1.title, description: featureLang[FeatureTypes.E_INVOICES].feature1.description, icon: ReceiptLongIcon },
      { title: featureLang[FeatureTypes.E_INVOICES].feature2.title, description: featureLang[FeatureTypes.E_INVOICES].feature2.description, icon: PathIcon },
      { title: featureLang[FeatureTypes.E_INVOICES].feature3.title, description: featureLang[FeatureTypes.E_INVOICES].feature3.description, icon: FileScanIcon },
      { title: featureLang[FeatureTypes.E_INVOICES].feature4.title, description: featureLang[FeatureTypes.E_INVOICES].feature4.description, icon: ClockIcon },
    ],
  },
  [FeatureTypes.OPTIONAL_POSITIONS]: {
    title: featureLang[FeatureTypes.OPTIONAL_POSITIONS].title,
    description: featureLang[FeatureTypes.OPTIONAL_POSITIONS].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.OPTIONAL_POSITIONS].subscriptionTypeLabel,
    featureMedia: OptionalPositionsBannerImage,
    features: [
      { title: featureLang[FeatureTypes.OPTIONAL_POSITIONS].feature1.title, description: featureLang[FeatureTypes.OPTIONAL_POSITIONS].feature1.description, icon: NoteStackIcon },
      { title: featureLang[FeatureTypes.OPTIONAL_POSITIONS].feature2.title, description: featureLang[FeatureTypes.OPTIONAL_POSITIONS].feature2.description, icon: CheckIcon },
      { title: featureLang[FeatureTypes.OPTIONAL_POSITIONS].feature3.title, description: featureLang[FeatureTypes.OPTIONAL_POSITIONS].feature3.description, icon: CalculateIcon },
      { title: featureLang[FeatureTypes.OPTIONAL_POSITIONS].feature4.title, description: featureLang[FeatureTypes.OPTIONAL_POSITIONS].feature4.description, icon: SignaturePenIcon },
    ],
  },
  [FeatureTypes.ALTERNATIVE_POSITIONS]: {
    title: featureLang[FeatureTypes.ALTERNATIVE_POSITIONS].title,
    description: featureLang[FeatureTypes.ALTERNATIVE_POSITIONS].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.ALTERNATIVE_POSITIONS].subscriptionTypeLabel,
    featureMedia: AlternativePositionsBannerImage,
    features: [
      { title: featureLang[FeatureTypes.ALTERNATIVE_POSITIONS].feature1.title, description: featureLang[FeatureTypes.ALTERNATIVE_POSITIONS].feature1.description, icon: NoteStackIcon },
      { title: featureLang[FeatureTypes.ALTERNATIVE_POSITIONS].feature2.title, description: featureLang[FeatureTypes.ALTERNATIVE_POSITIONS].feature2.description, icon: ListIcon },
      { title: featureLang[FeatureTypes.ALTERNATIVE_POSITIONS].feature3.title, description: featureLang[FeatureTypes.ALTERNATIVE_POSITIONS].feature3.description, icon: CalculateIcon },
      { title: featureLang[FeatureTypes.ALTERNATIVE_POSITIONS].feature4.title, description: featureLang[FeatureTypes.ALTERNATIVE_POSITIONS].feature4.description, icon: ListChecklistIcon },
    ],
  },
  [FeatureTypes.LETTER_PAPERS]: {
    title: featureLang[FeatureTypes.LETTER_PAPERS].title,
    description: featureLang[FeatureTypes.LETTER_PAPERS].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.LETTER_PAPERS].subscriptionTypeLabel,
    featureMedia: LetterPapersBannerImage,
    features: [
      { title: featureLang[FeatureTypes.LETTER_PAPERS].feature1.title, description: featureLang[FeatureTypes.LETTER_PAPERS].feature1.description, icon: FileCopyIcon },
      { title: featureLang[FeatureTypes.LETTER_PAPERS].feature2.title, description: featureLang[FeatureTypes.LETTER_PAPERS].feature2.description, icon: InsertDriveFileIcon },
      { title: featureLang[FeatureTypes.LETTER_PAPERS].feature3.title, description: featureLang[FeatureTypes.LETTER_PAPERS].feature3.description, icon: WindowIcon },
      { title: featureLang[FeatureTypes.LETTER_PAPERS].feature4.title, description: featureLang[FeatureTypes.LETTER_PAPERS].feature4.description, icon: FileRenewIcon },
    ],
  },
  [FeatureTypes.COLLECTIVE_INVOICE]: {
    title: featureLang[FeatureTypes.COLLECTIVE_INVOICE].title,
    description: featureLang[FeatureTypes.COLLECTIVE_INVOICE].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.COLLECTIVE_INVOICE].subscriptionTypeLabel,
    featureMedia: CollectiveInvoiceBannerImage,
    features: [
      { title: featureLang[FeatureTypes.COLLECTIVE_INVOICE].feature1.title, description: featureLang[FeatureTypes.COLLECTIVE_INVOICE].feature1.description, icon: FileEuroIcon },
      { title: featureLang[FeatureTypes.COLLECTIVE_INVOICE].feature2.title, description: featureLang[FeatureTypes.COLLECTIVE_INVOICE].feature2.description, icon: ListIcon },
      { title: featureLang[FeatureTypes.COLLECTIVE_INVOICE].feature3.title, description: featureLang[FeatureTypes.COLLECTIVE_INVOICE].feature3.description, icon: SignaturePenIcon },
      { title: featureLang[FeatureTypes.COLLECTIVE_INVOICE].feature4.title, description: featureLang[FeatureTypes.COLLECTIVE_INVOICE].feature4.description, icon: EyeIcon },
    ],
  },
  [FeatureTypes.GRADUATED_PRICE]: {
    title: featureLang[FeatureTypes.GRADUATED_PRICE].title,
    description: featureLang[FeatureTypes.GRADUATED_PRICE].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    type: subscriptionTypes.WARENWIRTSCHAFT_2026,
    subscriptionTypeLabel: featureLang[FeatureTypes.GRADUATED_PRICE].subscriptionTypeLabel,
    featureMedia: GraduatedPriceBannerImage,
    features: [
      { title: featureLang[FeatureTypes.GRADUATED_PRICE].feature1.title, description: featureLang[FeatureTypes.GRADUATED_PRICE].feature1.description, icon: CalculateIcon },
      { title: featureLang[FeatureTypes.GRADUATED_PRICE].feature2.title, description: featureLang[FeatureTypes.GRADUATED_PRICE].feature2.description, icon: MoneyBagIcon },
      { title: featureLang[FeatureTypes.GRADUATED_PRICE].feature3.title, description: featureLang[FeatureTypes.GRADUATED_PRICE].feature3.description, icon: SchemaIcon },
      { title: featureLang[FeatureTypes.GRADUATED_PRICE].feature4.title, description: featureLang[FeatureTypes.GRADUATED_PRICE].feature4.description, icon: StorefrontIcon },
    ],
  },
  [FeatureTypes.INVITE_USER]: {
    title: featureLang[FeatureTypes.INVITE_USER].title,
    description: featureLang[FeatureTypes.INVITE_USER].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    featureMedia: InviteUserBannerImage,
    features: [
      { title: featureLang[FeatureTypes.INVITE_USER].feature1.title, description: featureLang[FeatureTypes.INVITE_USER].feature1.description, icon: GroupIcon },
      { title: featureLang[FeatureTypes.INVITE_USER].feature2.title, description: featureLang[FeatureTypes.INVITE_USER].feature2.description, icon: PersonCheckIcon },
      { title: featureLang[FeatureTypes.INVITE_USER].feature3.title, description: featureLang[FeatureTypes.INVITE_USER].feature3.description, icon: PersonAddAlt1Icon },
      { title: featureLang[FeatureTypes.INVITE_USER].feature4.title, description: featureLang[FeatureTypes.INVITE_USER].feature4.description, icon: EyeIcon },
    ],
  },
  [FeatureTypes.REVENUE]: {
    title: featureLang[FeatureTypes.REVENUE].title,
    description: featureLang[FeatureTypes.REVENUE].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.REVENUE].subscriptionTypeLabel,
    featureMedia: RevenueBannerImage,
    features: [
      { title: featureLang[FeatureTypes.REVENUE].feature1.title, description: featureLang[FeatureTypes.REVENUE].feature1.description, icon: MoneyBagIcon },
      { title: featureLang[FeatureTypes.REVENUE].feature2.title, description: featureLang[FeatureTypes.REVENUE].feature2.description, icon: ReceiptLongIcon },
      { title: featureLang[FeatureTypes.REVENUE].feature3.title, description: featureLang[FeatureTypes.REVENUE].feature3.description, icon: FileCheckIcon },
      { title: featureLang[FeatureTypes.REVENUE].feature4.title, description: featureLang[FeatureTypes.REVENUE].feature4.description, icon: CheckIcon },
    ],
  },
  [FeatureTypes.TAX_REPORT]: {
    title: featureLang[FeatureTypes.TAX_REPORT].title,
    description: featureLang[FeatureTypes.TAX_REPORT].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.TAX_REPORT].subscriptionTypeLabel,
    featureMedia: TaxReportBannerImage,
    features: [
      { title: featureLang[FeatureTypes.TAX_REPORT].feature1.title, description: featureLang[FeatureTypes.TAX_REPORT].feature1.description, icon: FileRenewIcon },
      { title: featureLang[FeatureTypes.TAX_REPORT].feature2.title, description: featureLang[FeatureTypes.TAX_REPORT].feature2.description, icon: ListAltIcon },
      { title: featureLang[FeatureTypes.TAX_REPORT].feature3.title, description: featureLang[FeatureTypes.TAX_REPORT].feature3.description, icon: SendIcon },
      { title: featureLang[FeatureTypes.TAX_REPORT].feature4.title, description: featureLang[FeatureTypes.TAX_REPORT].feature4.description, icon: CheckIcon },
    ],
  },
  [FeatureTypes.ECONOMIC_ASSET]: {
    title: featureLang[FeatureTypes.ECONOMIC_ASSET].title,
    description: featureLang[FeatureTypes.ECONOMIC_ASSET].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.ECONOMIC_ASSET].subscriptionTypeLabel,
    featureMedia: EconomicAssetBannerImage,
    features: [
      { title: featureLang[FeatureTypes.ECONOMIC_ASSET].feature1.title, description: featureLang[FeatureTypes.ECONOMIC_ASSET].feature1.description, icon: ArrowSelectorToolIcon },
      { title: featureLang[FeatureTypes.ECONOMIC_ASSET].feature2.title, description: featureLang[FeatureTypes.ECONOMIC_ASSET].feature2.description, icon: ReceiptLongIcon },
      { title: featureLang[FeatureTypes.ECONOMIC_ASSET].feature3.title, description: featureLang[FeatureTypes.ECONOMIC_ASSET].feature3.description, icon: CheckbookIcon },
      { title: featureLang[FeatureTypes.ECONOMIC_ASSET].feature4.title, description: featureLang[FeatureTypes.ECONOMIC_ASSET].feature4.description, icon: WindowIcon },
    ],
  },
  [FeatureTypes.PURCHASES]: {
    title: featureLang[FeatureTypes.PURCHASES].title,
    description: featureLang[FeatureTypes.PURCHASES].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.PURCHASES].subscriptionTypeLabel,
    featureMedia: PurchasesBanner,
    features: [
      { title: featureLang[FeatureTypes.PURCHASES].feature1.title, description: featureLang[FeatureTypes.PURCHASES].feature1.description, icon: MonitorIcon },
      { title: featureLang[FeatureTypes.PURCHASES].feature2.title, description: featureLang[FeatureTypes.PURCHASES].feature2.description, icon: RouteTreeIcon },
      { title: featureLang[FeatureTypes.PURCHASES].feature3.title, description: featureLang[FeatureTypes.PURCHASES].feature3.description, icon: AwaitedDeliveryIcon },
      { title: featureLang[FeatureTypes.PURCHASES].feature4.title, description: featureLang[FeatureTypes.PURCHASES].feature4.description, icon: SettingsIcon },
    ],
  },
  [FeatureTypes.COLLECTIVE_DELIVERY_NOTES]: {
    title: featureLang[FeatureTypes.COLLECTIVE_DELIVERY_NOTES].title,
    description: featureLang[FeatureTypes.COLLECTIVE_DELIVERY_NOTES].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.COLLECTIVE_DELIVERY_NOTES].subscriptionTypeLabel,
    featureMedia: PartialAndCollectiveDeliveryNotesBanner,
    features: [
      { title: featureLang[FeatureTypes.COLLECTIVE_DELIVERY_NOTES].feature1.title, description: featureLang[FeatureTypes.COLLECTIVE_DELIVERY_NOTES].feature1.description, icon: FileNew },
      { title: featureLang[FeatureTypes.COLLECTIVE_DELIVERY_NOTES].feature2.title, description: featureLang[FeatureTypes.COLLECTIVE_DELIVERY_NOTES].feature2.description, icon: RouteTreeIcon },
      { title: featureLang[FeatureTypes.COLLECTIVE_DELIVERY_NOTES].feature3.title, description: featureLang[FeatureTypes.COLLECTIVE_DELIVERY_NOTES].feature3.description, icon: ClockIcon },
    ],
  },
  [FeatureTypes.PARTIAL_INVOICE]: {
    title: featureLang[FeatureTypes.PARTIAL_INVOICE].title,
    description: featureLang[FeatureTypes.PARTIAL_INVOICE].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    subscriptionTypeLabel: featureLang[FeatureTypes.PARTIAL_INVOICE].subscriptionTypeLabel,
    featureMedia: PartialInvoiceBannerImage,
    features: [
      { title: featureLang[FeatureTypes.PARTIAL_INVOICE].feature1.title, description: featureLang[FeatureTypes.PARTIAL_INVOICE].feature1.description, icon: FileNew },
      { title: featureLang[FeatureTypes.PARTIAL_INVOICE].feature2.title, description: featureLang[FeatureTypes.PARTIAL_INVOICE].feature2.description, icon: BranchIcon },
      { title: featureLang[FeatureTypes.PARTIAL_INVOICE].feature3.title, description: featureLang[FeatureTypes.PARTIAL_INVOICE].feature3.description, icon: EuroIcon },
    ],
  },
  [FeatureTypes.PUBLIC_API]: {
    title: featureLang[FeatureTypes.PUBLIC_API].title,
    description: featureLang[FeatureTypes.PUBLIC_API].description,
    subscriptionType: SubscriptionTypeTypes.Main as Type,
    moduleToAdd: SUBSCRIPTION_MODULES.PUBLIC_API,
    features: [
      { title: featureLang[FeatureTypes.PUBLIC_API].feature1.title, description: featureLang[FeatureTypes.PUBLIC_API].feature1.description, icon: ExtensionIcon },
      { title: featureLang[FeatureTypes.PUBLIC_API].feature2.title, description: featureLang[FeatureTypes.PUBLIC_API].feature2.description, icon: VpnKeyIcon },
      { title: featureLang[FeatureTypes.PUBLIC_API].feature3.title, description: featureLang[FeatureTypes.PUBLIC_API].feature3.description, icon: ApiIcon },
    ],
  },
} satisfies Record<FeatureType, FeatureConfig>

export default featureConfig
